// function swapYardageSelectorsInDrawer() {
//   document.querySelectorAll('.line-item[data-yardage-selector="true"]').forEach(function(lineItem) {
//     const qtySelector = lineItem.querySelector('.quantity-selector');
//     if (!qtySelector) return;

//     const backendMinQty = parseInt(lineItem.dataset.minQuantity) || 1;
//     const yardageMinQty = backendMinQty * 0.25; // Convert backend quarters to frontend yards

//     let yardageSelector = qtySelector.cloneNode(true);
//     if (yardageSelector.tagName.toLowerCase() === 'quantity-selector') {
//       const div = document.createElement('div');
//       div.className = yardageSelector.className;
//       for (const attr of yardageSelector.attributes) {
//         if (attr.name !== 'is' && attr.name !== 'class') {
//           div.setAttribute(attr.name, attr.value);
//         }
//       }
//       while (yardageSelector.firstChild) {
//         div.appendChild(yardageSelector.firstChild);
//       }
//       yardageSelector = div;
//     }

//     const input = yardageSelector.querySelector('input[type="number"], input.quantity-selector__input');
//     if (input) {
//       input.name = 'yardage_quantity';
//       input.inputMode = 'decimal';
//       input.step = '0.25';
//       input.min = yardageMinQty.toString();
//       const originalQty = parseInt(lineItem.querySelector('input[name="updates[]"]').value) || backendMinQty;
//       input.value = (originalQty * 0.25).toString();
//       input.setAttribute('aria-label', 'Change yardage');
//       input.id = 'yardage-input-' + lineItem.dataset.index;
//     }

//     let hidden = yardageSelector.querySelector('input[type="hidden"][name="updates[]"]');
//     const form = lineItem.closest('form');
//     const formId = form ? form.getAttribute('id') : null;
//     if (!hidden) {
//       hidden = document.createElement('input');
//       hidden.type = 'hidden';
//       hidden.name = 'quantity';
//       hidden.id = 'real-quantity-' + lineItem.dataset.index;
//       if (formId) hidden.setAttribute('form', formId);
//       yardageSelector.appendChild(hidden);
//     } else {
//       hidden.id = 'real-quantity-' + lineItem.dataset.index;
//       if (formId) hidden.setAttribute('form', formId);
//     }
//     hidden.value = lineItem.querySelector('input[name="updates[]"]').value;

//     const buttons = yardageSelector.querySelectorAll('.quantity-selector__button');
//     if (buttons.length === 2) {
//       buttons[0].id = 'decrease-yardage-' + lineItem.dataset.index;
//       buttons[0].disabled = false;
//       buttons[1].id = 'increase-yardage-' + lineItem.dataset.index;
//       buttons[1].disabled = false;
//     }

//     function updateUnitLabel(quantity) {
//       const container = lineItem.querySelector('.quantity-input');
//       if (!container) return;
//       let label = container.querySelector('.quantity-unit-label');
//       if (!label) {
//         label = document.createElement('span');
//         label.className = 'quantity-unit-label';
//         label.style.marginLeft = '0.5em';
//         container.appendChild(label);
//       }
//       label.textContent = (quantity > 0 && quantity <= 1) ? 'Yard' : 'Yards';
//     }

//     const yardageInput = input;
//     const realQuantity = hidden;
//     const increaseBtn = buttons[1];
//     const decreaseBtn = buttons[0];
//     const step = 0.25;
//     const min = yardageMinQty;

//     function updateRealQuantityAndLabel() {
//       const yardage = parseFloat(yardageInput.value) || min;
//       const quarters = Math.round(yardage / step);
//       realQuantity.value = quarters;
//       updateUnitLabel(yardage);
//     }

//     yardageInput.addEventListener('input', function () {
//       let value = parseFloat(yardageInput.value) || min;
//       value = Math.max(min, Math.round(value / step) * step);
//       yardageInput.value = value;
//       updateRealQuantityAndLabel();
      
//       // Update button disabled state
//       decreaseBtn.disabled = value <= min;
//     });

//     increaseBtn.addEventListener('click', function () {
//       let value = parseFloat(yardageInput.value) || min;
//       value += step;
//       yardageInput.value = value;
//       updateRealQuantityAndLabel();
      
//       // Update button disabled state
//       decreaseBtn.disabled = value <= min;
//     });

//     decreaseBtn.addEventListener('click', function () {
//       let value = parseFloat(yardageInput.value) || min;
//       value = Math.max(min, value - step);
//       yardageInput.value = value;
//       updateRealQuantityAndLabel();
      
//       // Update button disabled state
//       decreaseBtn.disabled = value <= min;
//     });

//     // Add change event listener to handle auto-removal when below minimum
//     yardageInput.addEventListener('change', function() {
//       const currentYardage = parseFloat(yardageInput.value) || min;
//       if (currentYardage < min) {
//         // Remove the item from cart by setting quantity to 0
//         const originalInput = lineItem.querySelector('input[name="updates[]"]');
//         const lineKey = originalInput?.dataset.lineKey;
//         if (lineKey) {
//           // Use the existing cart change functionality
//           const cartChangeUrl = `${window.Shopify?.routes?.root || '/'}cart/change.js`;
//           fetch(cartChangeUrl, {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//               id: lineKey,
//               quantity: 0
//             })
//           }).then(response => response.json()).then(cart => {
//             // Dispatch cart change event to update UI
//             document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
//               bubbles: true,
//               detail: {
//                 baseEvent: 'line-item:change',
//                 cart: cart
//               }
//             }));
//           }).catch(error => {
//             console.error('Error removing yardage item from cart:', error);
//             // Reset quantity input to minimum on error
//             yardageInput.value = min.toString();
//             updateRealQuantityAndLabel();
//           });
//         }
//       }
//     });

//     updateRealQuantityAndLabel();
    
//     // Set initial button state
//     decreaseBtn.disabled = parseFloat(yardageInput.value) <= min;

//     qtySelector.replaceWith(yardageSelector);
//   });
// }
// Theresa Nguyen commented above and added below for half yard increments to work on hlaf yard variants 2.11.2026
function swapYardageSelectorsInDrawer() {
  document
    .querySelectorAll('.line-item[data-yardage-selector="true"]')
    .forEach(function (lineItem) {
      const qtySelector = lineItem.querySelector(".quantity-selector");
      if (!qtySelector) return;

      const backendMinQty = parseInt(lineItem.dataset.minQuantity) || 1;

      // quarter vs half yard
      const yardageType = (lineItem.dataset.yardageType || "quarter").toLowerCase();
      const step = yardageType === "half" ? 0.5 : 0.25;

      // frontend minimum in yards
      const yardageMinQty =
        yardageType === "half"
          ? backendMinQty * 0.5 // 0.5 yard per unit
          : backendMinQty * 0.25; // 0.25 yard per unit

      let yardageSelector = qtySelector.cloneNode(true);
      if (yardageSelector.tagName.toLowerCase() === "quantity-selector") {
        const div = document.createElement("div");
        div.className = yardageSelector.className;
        for (const attr of yardageSelector.attributes) {
          if (attr.name !== "is" && attr.name !== "class") {
            div.setAttribute(attr.name, attr.value);
          }
        }
        while (yardageSelector.firstChild) {
          div.appendChild(yardageSelector.firstChild);
        }
        yardageSelector = div;
      }

      const input = yardageSelector.querySelector(
        'input[type="number"], input.quantity-selector__input'
      );
      if (input) {
        input.name = "yardage_quantity";
        input.inputMode = "decimal";
        input.step = step.toString();
        input.min = yardageMinQty.toString();

        const originalQty =
          parseInt(lineItem.querySelector('input[name="updates[]"]').value) ||
          backendMinQty;

        // convert backend units to yards
        const unitsToYardsFactor = yardageType === "half" ? 0.5 : 0.25;
        input.value = (originalQty * unitsToYardsFactor).toString();

        input.setAttribute("aria-label", "Change yardage");
        input.id = "yardage-input-" + lineItem.dataset.index;
      }

      let hidden = yardageSelector.querySelector(
        'input[type="hidden"][name="updates[]"]'
      );
      const form = lineItem.closest("form");
      const formId = form ? form.getAttribute("id") : null;
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "quantity";
        hidden.id = "real-quantity-" + lineItem.dataset.index;
        if (formId) hidden.setAttribute("form", formId);
        yardageSelector.appendChild(hidden);
      } else {
        hidden.id = "real-quantity-" + lineItem.dataset.index;
        if (formId) hidden.setAttribute("form", formId);
      }
      hidden.value = lineItem.querySelector('input[name="updates[]"]').value;

      const buttons = yardageSelector.querySelectorAll(
        ".quantity-selector__button"
      );
      if (buttons.length === 2) {
        buttons[0].id = "decrease-yardage-" + lineItem.dataset.index;
        buttons[0].disabled = false;
        buttons[1].id = "increase-yardage-" + lineItem.dataset.index;
        buttons[1].disabled = false;
      }

      function updateUnitLabel(quantity) {
        const container = lineItem.querySelector(".quantity-input");
        if (!container) return;
        let label = container.querySelector(".quantity-unit-label");
        if (!label) {
          label = document.createElement("span");
          label.className = "quantity-unit-label";
          label.style.marginLeft = "0.5em";
          container.appendChild(label);
        }
        label.textContent =
          quantity > 0 && quantity <= 1 ? "Yard" : "Yards";
      }

      const yardageInput = input;
      const realQuantity = hidden;
      const increaseBtn = buttons[1];
      const decreaseBtn = buttons[0];
      const min = yardageMinQty;

      function updateRealQuantityAndLabel() {
        const yardage = parseFloat(yardageInput.value) || min;
        const units = Math.round(yardage / step); // 0.25 or 0.5 per unit
        realQuantity.value = units;
        updateUnitLabel(yardage);
      }

      yardageInput.addEventListener("input", function () {
        let value = parseFloat(yardageInput.value) || min;
        value = Math.max(min, Math.round(value / step) * step);
        yardageInput.value = value;
        updateRealQuantityAndLabel();

        // Update button disabled state
        decreaseBtn.disabled = value <= min;
      });

      increaseBtn.addEventListener("click", function () {
        let value = parseFloat(yardageInput.value) || min;
        value += step;
        yardageInput.value = value;
        updateRealQuantityAndLabel();

        // Update button disabled state
        decreaseBtn.disabled = value <= min;
      });

      decreaseBtn.addEventListener("click", function () {
        let value = parseFloat(yardageInput.value) || min;
        value = Math.max(min, value - step);
        yardageInput.value = value;
        updateRealQuantityAndLabel();

        // Update button disabled state
        decreaseBtn.disabled = value <= min;
      });

      // Auto-removal below minimum (unchanged)
      yardageInput.addEventListener("change", function () {
        const currentYardage = parseFloat(yardageInput.value) || min;
        if (currentYardage < min) {
          const originalInput = lineItem.querySelector(
            'input[name="updates[]"]'
          );
          const lineKey = originalInput?.dataset.lineKey;
          if (lineKey) {
            const cartChangeUrl = `${
              window.Shopify?.routes?.root || "/"
            }cart/change.js`;
            fetch(cartChangeUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: lineKey,
                quantity: 0,
              }),
            })
              .then((response) => response.json())
              .then((cart) => {
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                      baseEvent: "line-item:change",
                      cart: cart,
                    },
                  })
                );
              })
              .catch((error) => {
                console.error(
                  "Error removing yardage item from cart:",
                  error
                );
                yardageInput.value = min.toString();
                updateRealQuantityAndLabel();
              });
          }
        }
      });

      updateRealQuantityAndLabel();

      // Initial button state
      decreaseBtn.disabled = parseFloat(yardageInput.value) <= min;

      qtySelector.replaceWith(yardageSelector);
    });
}


function setupCartDrawerYardageSwapper() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) {
    return;
  }

  swapYardageSelectorsInDrawer();

  cartDrawer.addEventListener('cart-drawer:refreshed', swapYardageSelectorsInDrawer);
  cartDrawer.addEventListener('dialog:after-show', swapYardageSelectorsInDrawer);
}

setupCartDrawerYardageSwapper();
